import { createFileRoute } from "@tanstack/react-router";
import { useOrganization } from "@/pages/organizations/detail";
import { useDocbuilder } from "@/pages/organizations/detail/builder";
import Docbuilders from "@/features/docbuilders/components/Docbuilders";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import { organizationDisplayName } from "@/common/classes/OrganizationUtils";

export const Route = createFileRoute("/app/organizations/$organizationId/builder/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organization } = useOrganization();
  const { headline, userCanViewDocbuilders } = useDocbuilder();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Home", link: "/app/account" },
          { title: "Organizations", link: "/app/organizations" },
          { title: organizationDisplayName(organization), link: `/app/organizations/${organization.id}` },
          { title: headline, link: null },
        ]}
      />
      <h1>{headline}</h1>
      <Docbuilders
        organization={organization}
        userCanViewDocbuilders={userCanViewDocbuilders}
      />
    </>
  );
}
